module.exports = __webpack_public_path__ + "assets/img/financing-hero.14a42271.webp";